import React from "react";

import "./style_new.scss";

const ChatWindowEmpty = ({ onNewConversation }) => {
  return (
    <div className="chatwindowopen selectany">
      <div className="messageindchat">
        <h3> Select Any Converstion Or Start A New Conversation </h3>
        <a href="#" className="btn btn-primary newconverbtn" onClick={onNewConversation} aria-label='new conversation'>
          New conversation
        </a>
      </div>
    </div>
  );
};

export default ChatWindowEmpty;
